import { render, staticRenderFns } from "./MenuTrigger.vue?vue&type=template&id=5aa87c60&lang=pug&"
import script from "./MenuTrigger.vue?vue&type=script&lang=js&"
export * from "./MenuTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports